// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription-container .subscription-heading h2 {
  font-weight: 400;
  line-height: 2.08125vw;
  letter-spacing: -2%;
  font-size: 2.08125vw;
}
.subscription-container .subscription-wrapper {
  background: radial-gradient(100% 100% at 0% 0%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%);
  border-radius: 0.20868vw;
  border: 2px solid;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  border-image-source: linear-gradient(169.15deg, rgba(255, 255, 255, 0.4) 0%, rgba(238, 237, 237, 0.2) 96.79%);
  padding: 2.5vw 2.22vw;
  margin-top: 1.11vw;
}
.subscription-container .react-switch-bg {
  border-radius: 0.97125vw !important;
}
.subscription-container .side-nav .main-content .subscription-container .subscription-wrapper {
  width: 61.43108vw;
}
.subscription-container table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
.subscription-container td.table-col {
  padding: 1.665vw 0.555vw 1.2vw;
}
.subscription-container th:nth-child(2) > div,
.subscription-container th:nth-child(3) > div,
.subscription-container th:nth-child(4) > div {
  background: linear-gradient(45deg, #b01f8d, #2e3896);
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  color: #ffffff;
  font-weight: 400;
  line-height: 1.24875vw;
  padding: 0.555vw 1.665vw;
  border-radius: 0.20868vw;
  margin: 0 0.555vw;
  text-align: left;
  border-bottom: 0px;
  position: relative;
}
.subscription-container th.active {
  background: linear-gradient(45deg, #9747ff, #ee3a24);
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  color: #ffffff;
  font-weight: 400;
  line-height: 1.24875vw;
  padding: 0.555vw 1.665vw;
  border-radius: 0.20868vw;
  transform: scale(1.25);
  transform: translate(0, -0.69375vw);
  margin: 0.2775vw;
  text-align: left;
}
.subscription-container .first-table-row td {
  border: none;
}
.subscription-container tr td:nth-child(1) {
  text-align: left;
}
.subscription-container .button-row td {
  border-bottom: 0px;
}
.subscription-container .button-row td {
  border-bottom: 0px;
}
.subscription-container td {
  border-bottom: 0.7px solid #ababab;
  text-align: center;
  padding: 1.665vw 0.555vw 0.555vw 0.555vw;
  font-weight: 600;
  font-size: 0.90243vw;
  line-height: 1.24875vw;
  color: #000000;
}
.subscription-container td.active {
  border-bottom: 1px solid #ababab;
  text-align: center;
  padding: 1.665vw 0.555vw 0.555vw 0.555vw;
  font-weight: 500;
  font-size: 0.90243vw;
  line-height: 1.24875vw;
  color: #000000;
}
.subscription-container .table-sub .caption {
  font-size: 0.88vw;
  position: absolute;
  top: 3%;
  right: 3%;
}
.subscription-container .table-sub .sub-name,
.subscription-container .table-sub .sub-price {
  font-size: 1.05vw;
  font-weight: 500;
  line-height: 1.25vw;
}
.subscription-container .table-sub .sub-desc {
  font-size: 0.901vw;
  display: inline-block;
  padding-bottom: 0.4vw;
  font-weight: 300;
  line-height: 1.25vw;
}
.subscription-container .react-switch {
  vertical-align: middle;
  margin-left: 0.2775vw;
}
.subscription-container .react-switch svg {
  display: none;
}
.subscription-container .react-switch-bg {
  height: 1.24875vw !important;
  width: 3.46875vw !important;
  margin: 0px;
  position: relative;
  background: #ffffff !important;
  border-radius: 0.97125vw;
  border: 0.5px solid #ffffff;
  cursor: pointer;
}
.subscription-container .react-switch-handle {
  height: 1.24875vw !important;
  width: 1.24875vw !important;
  background: linear-gradient(to bottom, #ee3a24, #f5f5f5) !important;
  display: inline-block;
  cursor: pointer;
  border-radius: 50%;
  position: absolute;
  transform: translateX(2.01243vw);
  top: 0.06993vw;
  outline: 0px;
  border: 0px;
  transition: background-color 0.25s ease 0s, transform 0.25s ease 0s, box-shadow 0.15s ease 0s;
}
.subscription-container .subscription-6-months,
.subscription-container .subscription-12-months {
  font-weight: 700;
  line-height: 1.24875vw;
  color: #3a3a3a;
  font-size: 1.04118vw;
  margin: 0 0.555vw;
}
.subscription-container .subscription-6-months.active,
.subscription-container .subscription-12-months.active {
  color: #ee3a24;
}
.subscription-container .toggle-switch {
  text-align: end;
  margin: 1.11vw 0;
}
.subscription-container .ten-percent-off {
  font-weight: 400;
  font-size: 0.90243vw;
  line-height: 1.24875vw;
  position: relative;
  top: -0.555vw;
  left: -0.555vw;
  color: #b01f8d;
}
.subscription-container .continue {
  border: 1px solid #ee3a24;
  border-radius: 0.20868vw;
  width: 14.36118vw;
  height: 3.0525vw;
  font-weight: 500;
  line-height: 1.24875vw;
  font-size: 0.90243vw;
  color: #ee3a24;
  background-color: #ffffff;
  cursor: pointer;
}
.subscription-container .continue.active {
  background-color: #ee3a24;
  border-radius: 0.20868vw;
  padding: 0.8325vw 2.775vw;
  border: none;
  color: #fff;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/style/components/dashboard/Subscription.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AAAJ;AAEE;EACE,yGAAA;EAKA,wBAAA;EACA,iBAAA;EACA,+DAAA;EACA,6GAAA;EAKA,qBAAA;EACA,kBAAA;AARJ;AAUE;EACE,mCAAA;AARJ;AAUE;EACE,iBAAA;AARJ;AAUE;EACE,8BAAA;EACA,yBAAA;EACA,WAAA;AARJ;AAUE;EACE,8BAAA;AARJ;AAUE;;;EAGE,oDAAA;EACA,+DAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AARJ;AAUE;EACE,oDAAA;EACA,+DAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,sBAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;AARJ;AAUE;EACE,YAAA;AARJ;AAUE;EACE,gBAAA;AARJ;AAWE;EACE,kBAAA;AATJ;AAYE;EACE,kBAAA;AAVJ;AAYE;EACE,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,cAAA;AAVJ;AAYE;EACE,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,cAAA;AAVJ;AAcI;EACE,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AAZN;AAeI;;EAEE,iBAAA;EACA,gBAAA;EACA,mBAAA;AAbN;AAgBE;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AAdJ;AAgBE;EACE,sBAAA;EACA,qBAAA;AAdJ;AAgBE;EACE,aAAA;AAdJ;AAgBE;EACE,4BAAA;EACA,2BAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,wBAAA;EACA,2BAAA;EACA,eAAA;AAdJ;AAgBE;EACE,4BAAA;EACA,2BAAA;EACA,mEAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,6FAAA;AAdJ;AAiBE;;EAEE,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;AAfJ;AAiBE;;EAEE,cAAA;AAfJ;AAiBE;EACE,eAAA;EACA,gBAAA;AAfJ;AAiBE;EACE,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;AAfJ;AAiBE;EACE,yBAAA;EACA,wBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;AAhBJ;AAkBE;EACE,yBAAA;EACA,wBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAhBJ","sourcesContent":[".subscription-container {\n  .subscription-heading h2 {\n    font-weight: 400;\n    line-height: 2.08125vw;\n    letter-spacing: -2%;\n    font-size: 2.08125vw;\n  }\n  .subscription-wrapper {\n    background: radial-gradient(\n      100% 100% at 0% 0%,\n      rgba(255, 255, 255, 0.4) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n    border-radius: 0.20868vw;\n    border: 2px solid;\n    box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n    border-image-source: linear-gradient(\n      169.15deg,\n      rgba(255, 255, 255, 0.4) 0%,\n      rgba(238, 237, 237, 0.2) 96.79%\n    );\n    padding: 2.5vw 2.22vw;\n    margin-top: 1.11vw;\n  }\n  .react-switch-bg {\n    border-radius: 0.97125vw !important;\n  }\n  .side-nav .main-content .subscription-container .subscription-wrapper {\n    width: 61.43108vw;\n  }\n  table {\n    font-family: arial, sans-serif;\n    border-collapse: collapse;\n    width: 100%;\n  }\n  td.table-col {\n    padding: 1.665vw 0.555vw 1.2vw;\n  }\n  th:nth-child(2) > div,\n  th:nth-child(3) > div,\n  th:nth-child(4) > div {\n    background: linear-gradient(45deg, #b01f8d, #2e3896);\n    box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n    color: #ffffff;\n    font-weight: 400;\n    line-height: 1.24875vw;\n    padding: 0.555vw 1.665vw;\n    border-radius: 0.20868vw;\n    margin: 0 0.555vw;\n    text-align: left;\n    border-bottom: 0px;\n    position: relative;\n  }\n  th.active {\n    background: linear-gradient(45deg, #9747ff, #ee3a24);\n    box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n    color: #ffffff;\n    font-weight: 400;\n    line-height: 1.24875vw;\n    padding: 0.555vw 1.665vw;\n    border-radius: 0.20868vw;\n    transform: scale(1.25);\n    transform: translate(0, -0.69375vw);\n    margin: 0.2775vw;\n    text-align: left;\n  }\n  .first-table-row td {\n    border: none;\n  }\n  tr td:nth-child(1) {\n    text-align: left;\n  }\n\n  .button-row td {\n    border-bottom: 0px;\n  }\n\n  .button-row td {\n    border-bottom: 0px;\n  }\n  td {\n    border-bottom: 0.7px solid #ababab;\n    text-align: center;\n    padding: 1.665vw 0.555vw 0.555vw 0.555vw;\n    font-weight: 600;\n    font-size: 0.90243vw;\n    line-height: 1.24875vw;\n    color: #000000;\n  }\n  td.active {\n    border-bottom: 1px solid #ababab;\n    text-align: center;\n    padding: 1.665vw 0.555vw 0.555vw 0.555vw;\n    font-weight: 500;\n    font-size: 0.90243vw;\n    line-height: 1.24875vw;\n    color: #000000;\n    //  background-color: gainsboro;\n  }\n  .table-sub {\n    .caption {\n      font-size: 0.88vw;\n      position: absolute;\n      top: 3%;\n      right: 3%;\n    }\n\n    .sub-name,\n    .sub-price {\n      font-size: 1.05vw;\n      font-weight: 500;\n      line-height: 1.25vw;\n    }\n  }\n  .table-sub .sub-desc {\n    font-size: 0.901vw;\n    display: inline-block;\n    padding-bottom: 0.4vw;\n    font-weight: 300;\n    line-height: 1.25vw;\n  }\n  .react-switch {\n    vertical-align: middle;\n    margin-left: 0.2775vw;\n  }\n  .react-switch svg {\n    display: none;\n  }\n  .react-switch-bg {\n    height: 1.24875vw !important;\n    width: 3.46875vw !important;\n    margin: 0px;\n    position: relative;\n    background: #ffffff !important;\n    border-radius: 0.97125vw;\n    border: 0.5px solid #ffffff;\n    cursor: pointer;\n  }\n  .react-switch-handle {\n    height: 1.24875vw !important;\n    width: 1.24875vw !important;\n    background: linear-gradient(to bottom, #ee3a24, #f5f5f5) !important;\n    display: inline-block;\n    cursor: pointer;\n    border-radius: 50%;\n    position: absolute;\n    transform: translateX(2.01243vw);\n    top: 0.06993vw;\n    outline: 0px;\n    border: 0px;\n    transition: background-color 0.25s ease 0s, transform 0.25s ease 0s,\n      box-shadow 0.15s ease 0s;\n  }\n  .subscription-6-months,\n  .subscription-12-months {\n    font-weight: 700;\n    line-height: 1.24875vw;\n    color: #3a3a3a;\n    font-size: 1.04118vw;\n    margin: 0 0.555vw;\n  }\n  .subscription-6-months.active,\n  .subscription-12-months.active {\n    color: #ee3a24;\n  }\n  .toggle-switch {\n    text-align: end;\n    margin: 1.11vw 0;\n  }\n  .ten-percent-off {\n    font-weight: 400;\n    font-size: 0.90243vw;\n    line-height: 1.24875vw;\n    position: relative;\n    top: -0.555vw;\n    left: -0.555vw;\n    color: #b01f8d;\n  }\n  .continue {\n    border: 1px solid #ee3a24;\n    border-radius: 0.20868vw;\n    // padding: 0.8325vw 2.775vw;\n    width: 14.36118vw;\n    height: 3.0525vw;\n    font-weight: 500;\n    line-height: 1.24875vw;\n    font-size: 0.90243vw;\n    color: #ee3a24;\n    background-color: #ffffff;\n    cursor: pointer;\n  }\n  .continue.active {\n    background-color: #ee3a24;\n    border-radius: 0.20868vw;\n    padding: 0.8325vw 2.775vw;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
